export default "__VITE_ASSET__CfR70nvG__"